export default __webpack_public_path__ + "static/media/nestclock.67a0b910.svg";